import React from 'react';
import { Card } from '@blueprintjs/core';
import PerformanceComment from '../../../models/PerformanceComment';
import moment from 'moment';
import Button from '../../controls/forms/redesign/FormButton';
import Landman from 'src/models/Landman';

interface ILandmanCommentCardProps {
    landman: Landman;
    performanceComments: Array<PerformanceComment>;
    onAddCommentClick: () => void;
    navigate: (path: string) => void;
}

type LandmanCommentCardState = {
    activeComment: number;
};

class LandmanCommentCard extends React.Component<ILandmanCommentCardProps, LandmanCommentCardState> {
    readonly state: Readonly<LandmanCommentCardState> = {
        activeComment: 0,
    };

    commentClass = (commentIndex: number) => {
        if (this.props.performanceComments[commentIndex].isApproved) {
            return 'comment-header';
        }
        return 'comment-not-approved-header';
    };

    onNextCommentClick = (numComments: number) => {
        if (this.state.activeComment < numComments - 1) {
            this.setState({ activeComment: this.state.activeComment + 1 });
        }
    };

    onPrevCommentClick = () => {
        if (this.state.activeComment > 0) {
            this.setState({ activeComment: this.state.activeComment - 1 });
        }
    };

    onManageCommentsClick = () => {
        this.props.navigate(`/landmen/${this.props.landman.id}/manage-comments`);
    };

    public render() {
        const comments = this.props.performanceComments;

        // Reverse Sort to display newest comment first
        if (comments !== undefined && comments.length !== 0) {
            comments.sort((a: PerformanceComment, b: PerformanceComment) => {
                const aDate = new Date(a.commentDate).getTime();
                const bDate = new Date(b.commentDate).getTime();
                return bDate - aDate;
            });
        }

        return (
            <Card className="lh-half-width landman-experience-panel" elevation={1}>
                <h6>Performance</h6>
                {comments !== undefined && comments.length !== 0 ? (
                    <div>
                        <div className={this.commentClass(this.state.activeComment)}>
                            {moment(comments[this.state.activeComment].commentDate).format('LLL') +
                                ' ' +
                                ' by ' +
                                comments[this.state.activeComment].authorFirstName +
                                ' ' +
                                comments[this.state.activeComment].authorLastName}
                            <Button intent="primary" size="medium" icon="add" text="Add Comment" onClick={this.props.onAddCommentClick} />
                        </div>
                        <div className="comment"> {comments[this.state.activeComment].commentText}</div>
                        <div className="comment-pager">
                            <span>
                                Comment {this.state.activeComment + 1} of {comments.length}
                            </span>
                            <span style={{ textAlign: 'right', position: 'relative' }}>
                                <Button
                                    size="medium"
                                    text="< Prev"
                                    onClick={() => this.onPrevCommentClick()}
                                    disabled={this.state.activeComment === 0}
                                />
                                <Button
                                    size="medium"
                                    text="Next >"
                                    onClick={() => this.onNextCommentClick(comments.length)}
                                    disabled={this.state.activeComment + 1 === comments.length}
                                />
                            </span>
                        </div>
                        <div style={{ marginTop: '.5em', textAlign: 'right' }}>
                            <Button intent="primary" size="medium" onClick={this.onManageCommentsClick} text="Manage Comments" />
                        </div>
                    </div>
                ) : (
                    <span>
                        {' '}
                        No Comments Available
                        <div style={{ marginTop: '.5em', textAlign: 'right' }}>
                            <Button intent="primary" size="medium" text="Add Comment" onClick={this.props.onAddCommentClick} />
                        </div>
                    </span>
                )}
            </Card>
        );
    }
}

export default LandmanCommentCard;



// WEBPACK FOOTER //
// ./src/components/personnel/components/LandmanCommentCard.tsx